import { GET, PUT, DELETE, POST } from "constants/methods";

import { REACT_APP_API_PREFIX } from "config/env";

const service = "account";
const accessTokens = `${REACT_APP_API_PREFIX}/${service}/accessTokens`;
const currentUserAccessTokens = `${REACT_APP_API_PREFIX}/${service}/users/current/accessTokens`;

export function getAccessTokens() {
  const url = `${accessTokens}`;
  return {
    method: GET,
    url,
  };
}

export function getAccessTokenById(id) {
  const url = `${accessTokens}/${id}`;
  return {
    method: GET,
    url,
  };
}

export function updateAccessToken(id, body) {
  const url = `${accessTokens}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteAccessToken(id) {
  const url = `${accessTokens}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createAccessToken(body) {
  const url = `${currentUserAccessTokens}`;
  return {
    method: POST,
    url,
    body,
  };
}
